// src/components/shippingdetailsHelper/shippingdetailsHelper.js
import { updateProfile } from '../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

export const updateShippingDataToProfile = location => {
  return (dispatch, getState, sdk) => {
    const state = getState();
    const deliveryPrivateData = state.user.currentUser?.attributes?.profile?.privateData || {};

    const { deliveryDoor = [], deliveryLocker = [] } = deliveryPrivateData;
    const {
      addressCategory = 'delivery',
      location: {
        selectedPlace: { address, origin, bounds, ...restPredictionValues } = {},
        selectedLocker,
      } = {},
      addressType,
      building,
      shippingType,
    } = location;
    let newData = {};

    // if (location.location.selectedPlace) {
    //   newData = {
    //     shippingType,
    //     addressType,
    //     building,
    //     location: {
    //       address,
    //       origin,
    //     },
    //   };
    // }

    if (selectedLocker) {
      // Save delivery locker
      if (deliveryLocker.length >= 3) {
        return Promise.resolve();
      }
      newData = {
        ...selectedLocker,
        type: 'locker',
        id: Date.now(),
      };
      const updatedLockerList = [...deliveryLocker, newData];
      return dispatch(updateProfile({ privateData: { deliveryLocker: updatedLockerList } }));
    } else if (location.location.selectedPlace) {
      if (deliveryDoor.length >= 3) {
        return Promise.resolve();
      }
      // Save delivery door
      newData = {
        address,
        shippingType,
        addressType,
        building,
        location: {
          address,
          origin,
        },
        selectedPlace: { ...restPredictionValues },
        type: 'door',
        id: Date.now(),
      };

      const updatedDoorList = [...deliveryDoor, newData];
      // return dispatch(updateProfile({ privateData: { deliveryDoor: updatedDoorList } }));
      if (deliveryDoor.length === 0) {
        const updatedPrivateData = {
          ...deliveryPrivateData,
          deliveryDoor: updatedDoorList,
          deliveryDoorDefault: newData.id, // <-- fixed key
        };

        return dispatch(updateProfile({ privateData: updatedPrivateData }));
      } else {
        return dispatch(updateProfile({ privateData: { deliveryDoor: updatedDoorList } }));
      }
    }
  };
};
